import React, { useState } from 'react';
import { MapView } from './MapView';
import { ActivePasses } from '../students/ActivePasses';
import { ListView } from '../students/ListView';
import { useStudentData } from '../../../hooks/useStudentData';
import { Maximize } from 'lucide-react';

enum TabType {
  MAP = 'map',
  LIST = 'list',
  ACTIVE = 'active',
}

export const MaraudersMap: React.FC = () => {
  const studentData = useStudentData();
  const [activeTab, _setActiveTab] = useState<TabType>(TabType.MAP);
  const [isFullScreen, setIsFullScreen] = useState(false);

  const handleToggleFullScreen = () => {
    setIsFullScreen(!isFullScreen);
  };

  // Show loading state while data is being fetched
  if (studentData.loading) {
    return (
      <div className="h-full flex items-center justify-center text-stone-800">
        <div className="flex flex-col items-center gap-4">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-stone-800"></div>
          <p>Loading hall pass data...</p>
        </div>
      </div>
    );
  }

  return (
    <div className={`${isFullScreen ? 'fixed inset-0 z-50 bg-amber-50' : 'h-full'} text-stone-800 flex flex-col`}>
      <div className="flex-1 flex flex-col overflow-hidden">
        <div className="w-full flex flex-col h-full relative">
          {/* Only show this button when NOT in fullscreen mode, since MapView will show its own */}
          {!isFullScreen && (
            <button
              onClick={handleToggleFullScreen}
              className="absolute top-4 right-4 z-10 p-2 bg-white/80 hover:bg-white rounded-lg shadow-sm transition-colors"
              title="Enter fullscreen"
            >
              <Maximize className="w-5 h-5" />
            </button>
          )}
          {/* Content based on active tab */}
          <div className="flex-1 bg-amber-100/50 rounded-lg shadow-md overflow-hidden">
            {activeTab === TabType.MAP && (
              <MapView
                students={studentData.students}
                locations={studentData.locations}
                paths={studentData.paths}
                studentPositions={studentData.studentPositions}
                editingMap={studentData.editingMap}
                setEditingMap={studentData.setEditingMap}
                mapImage={studentData.mapImage}
                updateLocationPosition={studentData.updateLocationPosition}
                updatePathWaypoints={studentData.updatePathWaypoints}
                saveMapConfig={studentData.saveMapConfig}
                addStudent={studentData.addStudent}
                addPath={studentData.addPath}
                deletePath={studentData.deletePath}
                addLocation={studentData.addLocation}
                updateLocation={studentData.updateLocation}
                deleteLocation={studentData.deleteLocation}
                markStudentReturned={studentData.markStudentReturned}
                isFullScreen={isFullScreen}
                onToggleFullScreen={handleToggleFullScreen}
              />
            )}
            {activeTab === TabType.LIST && (
              <ListView 
                students={studentData.students}
                locations={studentData.locations}
                markStudentReturned={studentData.markStudentReturned}
                removeStudent={studentData.removeStudent}
              />
            )}
            {activeTab === TabType.ACTIVE && (
              <ActivePasses 
                students={studentData.getActiveStudents()}
                locations={studentData.locations}
                markStudentReturned={studentData.markStudentReturned}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};